<iframe
    *ngIf="embedURL"
    id="embed"
    title="embed"
    height="95%"
    width="100%"
    style="border: none"
    [src]="embedURL"
></iframe>
